const logger = require('od-modules/utils/logger');
const frontendShell = require('./index');
const frontendShellFlightResults = require('./flightResults');

const createFrontendShellHandlers = ({modelErrorManagement, errorManagement}) => {
    return {
        globalEvents: {
            'frontend-shell:javascript-error': 'onFrontendShellRenderError',
            'frontend-shell:restore-render-error': 'onRestoreRenderError',
            'frontend-shell:frontend-api-error': 'onFrontendAPIError',
            'frontend-shell:info': 'onFrontendShellInfo',
            'frontend-shell:warning': 'onFrontendShellWarning',
            'frontend-shell:session-expired': 'onSessionExpired',
        },
        eventHandlers: {
            onFrontendShellRenderError(error, message) {
                Odigeo.UIElements.showBrokenFlowError();
                this.onFrontendShellWarning(error, message);
            },

            onRestoreRenderError() {
                if (frontendShellFlightResults.isEnabled()) {
                    frontendShell.execute(({error, page}) => {
                        page.navigate(Odigeo.History.getPageNameFromFragment());
                        error.restore();
                    });
                }
            },

            onFrontendAPIError(errors) {
                errorManagement.handleGenericErrorCodes(errors, {
                    handler: modelErrorManagement,
                    defaultHandler: modelErrorManagement.defaultError,
                });
            },

            onFrontendShellInfo(error, message) {
                if (error) {
                    logger.info(`OF2_SHELL - ${message || error.message}`);
                }
            },

            onFrontendShellWarning(error, message) {
                if (error) {
                    logger.error(error, `OF2_SHELL - ${message || error.message}`);
                }
            },

            onSessionExpired() {},
        },
    };
};

module.exports = createFrontendShellHandlers;
